import React from "react";
import Navbar from "./Navbar";
import vivacePDF from "/vivace_brochure.pdf";
const emailGeneral = import.meta.env.VITE_EMAIL_GENERAL;

function ContactSection() {
  const [email, setEmail] = React.useState("");

  const handleSend = (e) => {
    e.preventDefault();
    if (!email) return alert("Please enter your email");
    window.location.href =
      `mailto:${emailGeneral}?subject=Vivaceinternational.com Query (New Customer!)&body=User email: ${encodeURIComponent(email)}`;
  };
  return (
    <div className="flex flex-col md:flex-row bg-gray-50 p-10" id="contact-section">
      {/* Contact Form */}
      <div className="flex-1 md:flex-[2] flex flex-col justify-center bg-white p-8 rounded-2xl shadow-lg hover:shadow-2xl transition-shadow">
        <h2 className="text-3xl font-bold mb-6 text-center md:text-left text-blue-700">
          Contact Us
        </h2>
        <form className="flex flex-col gap-5">
          <input
            type="text"
            placeholder="Your Name"
            className="p-4 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-400"
          />
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}

            placeholder="Your Email"
            className="p-4 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-400"
          />
          <textarea
            placeholder="Your Message"
            rows={5}
            className="p-4 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-400 resize-none"
          />
          <button
            onClick={handleSend}
            className="bg-blue-600 text-white py-4 rounded-lg font-semibold cursor-pointer
            hover:bg-blue-700 hover:scale-105 hover:shadow-xl transition-transform transition-colors duration-300"
          >
            Send Message
          </button>
        </form>
      </div>
    </div>
  );
}

export default function CatalogPage() {

  return (
    <>
      <Navbar
        links={[
          { href: "/#home", label: "Home" },
          { href: "/#about", label: "About Us" },
          { href: "/#services", label: "Our Service" },
          { href: "/#newsletter", label: "Contact Us" },
        ]}
      />

      <div className="max-w-4xl mx-auto mt-30 px-4 relative">
        {/* PDF Embed with styling */}
        <div className="w-full h-[50vh] lg:h-[85vh] rounded-2xl shadow-xl bg-gray-100 flex justify-center 
            items-center p-3 relative overflow-hidden">
          <iframe
            src={`${vivacePDF}#toolbar=0&navpanes=0&scrollbar=0`}
            className="w-full h-full rounded-xl"
            title="Vivace Brochure"
            frameBorder="0"
          />
          {/* Download Button */}
          <a
            href={vivacePDF}
            download
            className=" absolute top-0 bg-blue-600 text-white p-3 rounded-lg shadow hover:bg-blue-700 transition"
          >
            Download Brochure
          </a>
        </div>

      </div>
      {/* Scroll Down Indicator */}
      <div
        className="hidden md:flex flex-col items-center gap-1 absolute right-8 lg:right-50 top-1/2
        		-translate-y-1/2 animate-bounce cursor-pointer select-none"
        onClick={() => {
          document.querySelector('#contact-section')?.scrollIntoView({ behavior: 'smooth' });
        }}
      >
        <div className="w-12 h-12 bg-blue-600 text-white rounded-full flex items-center justify-center shadow-lg text-2xl">
          ↓
        </div>
        <p className="text-sm font-semibold text-blue-700 text-center">Contact Us!</p>
      </div>



      {/* Contact Form */}
      <ContactSection />
    </>
  );
}
